import { AnnotationsFlyoutButton } from "@features/custom-annotations";
import { usePageConfiguration } from "@features/sales-v3/hooks";
import { type SalesPageMetric } from "@north-beam/nb-client-side";

import { ChartAlignAxesScaleToggle } from "./chart-align-axes-scale-toggle";
import { ChartTypesButtons } from "./chart-types-buttons";
import { ChartViewsButtons } from "./chart-views-buttons";
import { MetricsControl } from "./metrics-control";

interface ChartConfiguratorProps {
  chartIndex: number;
  metrics: SalesPageMetric[];
  disabledChartOptions?: boolean;
}

export const ChartConfigurator = ({
  chartIndex,
  metrics,
  disabledChartOptions = false,
}: ChartConfiguratorProps) => {
  const { dateRangeInterval } = usePageConfiguration();

  return (
    <div className="flex justify-between items-start">
      <MetricsControl
        metrics={metrics}
        chartIndex={chartIndex}
        disabled={disabledChartOptions}
      />
      <div className="flex space-x-3 items-end">
        <ChartViewsButtons chartIndex={chartIndex} />
        <div className="border-r w-0.5 h-8" />
        <ChartTypesButtons
          chartIndex={chartIndex}
          disabled={disabledChartOptions}
        />
        <div className="border-r w-0.5 h-8" />
        <ChartAlignAxesScaleToggle
          chartIndex={chartIndex}
          disabled={disabledChartOptions}
        />
        <div className="border-r w-0.5 h-8" />
        <AnnotationsFlyoutButton
          dateRange={dateRangeInterval}
          disabled={disabledChartOptions}
        />
      </div>
    </div>
  );
};
